export function extractDaysOfTheMonth(date: Date) {
  const days = [];
  const daysOfMonth = new Date(date.getFullYear(), date.getMonth() + 1, 0).getDate();
  for (let i = 1; i <= daysOfMonth; i++) {
    days.push(i);
  }
  return days;
}

export const getDaysArray = (start: Date, end: Date, lang: string) => {
  const days =
    lang === 'en'
      ? ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
      : ['Sonntag', 'Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag'];

  const arr = [];
  for (let dt = new Date(start); dt <= end; dt.setDate(dt.getDate() + 1)) {
    const date = new Date(dt);
    const newDate = {
      date,
      dayOfTheMonth: date.getDate(),
      day: days[date.getDay()],
    };
    arr.push(newDate);
  }
  return arr;
};
